<div class="min-h-screen flex flex-col">
  <app-header class="sticky top-0 z-50"></app-header>
  <main class="flex-1 flex flex-col">
    <router-outlet />
  </main>
  <app-footer></app-footer>
</div>
